import React, { useContext } from "react";
import PropTypes from "prop-types";
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";

import { FormatAsDollars } from "../../../utils/Helpers/Format";

import Range from "../../shared/InputElements/Range";

const descriptionFn = val => {
  return `< ${FormatAsDollars(val)}`;
};

const SlideHomeChargerPrice = ({
  id = "charger-price-range",
  label = "Price",
  description = descriptionFn,
  ...rest
}) => {
  const userPrefs = useContext(UserPrefsContext);

  return (
    <Range
      id={id}
      value={userPrefs.get("chargerBudget")}
      label={label}
      ariaLabel={label}
      rangeMin={200}
      rangeMax={2000}
      rangeStep={100}
      description={description}
      ariaControls="home-chargers-catalog"
      handler={e => userPrefs.set({ chargerBudget: e.target.value })}
      {...rest}
    />
  );
};

export default SlideHomeChargerPrice;

SlideHomeChargerPrice.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.func
};
